import { createBrowserRouter } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";

//Pages for app
import Home from "./pages/Home";
import About from "./pages/About";
import Resources from "./pages/Resources";
import Profile from "./pages/Profile";
import Register from "./pages/Register";

import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import Module_1_Overview from "./pages/Module-1/Overview";
import Module_1_Indications from "./pages/Module-1/Indications";
import Module_1_ISI from "./pages/Module-1/isi";
import Module_101 from "./pages/Module-1/101";
import Module_102 from "./pages/Module-1/102";
import Module_103 from "./pages/Module-1/103";
import Module_104 from "./pages/Module-1/104";
import Module_105 from "./pages/Module-1/104";
import Module_111 from "./pages/Module-1/111";
import Module_112 from "./pages/Module-1/112";
// import Module_113 from "./pages/Module-1/113";
// import Module_114 from "./pages/Module-1/114";
import Module_121 from "./pages/Module-1/121";
import Module_122 from "./pages/Module-1/122";
import Module_123 from "./pages/Module-1/123";
import Module_124 from "./pages/Module-1/124";
import Module_125 from "./pages/Module-1/125";
import Module_131 from "./pages/Module-1/131";
import Module_132 from "./pages/Module-1/132";
import Module_133 from "./pages/Module-1/133";
import Module_134 from "./pages/Module-1/134";
import Module_135 from "./pages/Module-1/135";
import Module_136 from "./pages/Module-1/136";
import Module_2_Overview from "./pages/Module-2/Overview";
import Module_2_Indications from "./pages/Module-2/Indications";
import Module_2_ISI from "./pages/Module-2/isi";
import Module_200 from "./pages/Module-2/200";

import Module_211 from "./pages/Module-2/211";
import Module_212 from "./pages/Module-2/212";
import Module_213 from "./pages/Module-2/213";
import Module_214 from "./pages/Module-2/214";
import Module_215 from "./pages/Module-2/215";

import Module_220 from "./pages/Module-2/220";
import Module_221 from "./pages/Module-2/221";
import Module_222 from "./pages/Module-2/222";
import Module_223 from "./pages/Module-2/223";
import Module_224 from "./pages/Module-2/224";
import Module_225 from "./pages/Module-2/225";
import Module_226 from "./pages/Module-2/226";
import Module_227 from "./pages/Module-2/227";
import Module_228 from "./pages/Module-2/228";
import Module_229 from "./pages/Module-2/229";
import Module_2210 from "./pages/Module-2/2210";
import Module_2211 from "./pages/Module-2/2211";

import Module_230 from "./pages/Module-2/230";
import Module_231 from "./pages/Module-2/231";
import Module_232 from "./pages/Module-2/232";
import Module_233 from "./pages/Module-2/233";

import Module_234 from "./pages/Module-2/234";
import Module_235 from "./pages/Module-2/235";
import Module_236 from "./pages/Module-2/236";
import Module_237 from "./pages/Module-2/237";
import Module_238 from "./pages/Module-2/238";

import Module_240 from "./pages/Module-2/240";
import Module_241 from "./pages/Module-2/241";
import Module_242 from "./pages/Module-2/242";
import Module_243 from "./pages/Module-2/243";
import Module_244 from "./pages/Module-2/244";
import Module_245 from "./pages/Module-2/245";
import Module_246 from "./pages/Module-2/246";
import Module_247 from "./pages/Module-2/247";
import Module_248 from "./pages/Module-2/248";
import Module_249 from "./pages/Module-2/249";
import Module_2410 from "./pages/Module-2/2410";
import Module_2411 from "./pages/Module-2/2411";

import Module_3_Overview from "./pages/Module-3/Overview";
import Module_3_Indications from "./pages/Module-3/Indications";
import Module_3_ISI from "./pages/Module-3/isi";
import Module_300 from "./pages/Module-3/300";
import Module_301 from "./pages/Module-3/301";
import Module_302 from "./pages/Module-3/302";
import Module_303 from "./pages/Module-3/303";
import Module_304 from "./pages/Module-3/304";
import Module_305 from "./pages/Module-3/305";
import Module_306 from "./pages/Module-3/306";
import Module_307 from "./pages/Module-3/307";
import Module_308 from "./pages/Module-3/308";
import Module_309 from "./pages/Module-3/309";
import Module_3010 from "./pages/Module-3/3010";
import Module_3011 from "./pages/Module-3/3011";
import Module_3012 from "./pages/Module-3/3012";
import Module_3013 from "./pages/Module-3/3013";
import Module_3014 from "./pages/Module-3/3014";
import Module_3015 from "./pages/Module-3/3015";
import Module_3016 from "./pages/Module-3/3016";
import Module_3017 from "./pages/Module-3/3017";
import Module_3018 from "./pages/Module-3/3018";
import Module_3019 from "./pages/Module-3/3019";
import Module_3020 from "./pages/Module-3/3020";
import Module_3021 from "./pages/Module-3/3021";
import Module_4_Overview from "./pages/Module-4/Overview";
import Module_4_Indications from "./pages/Module-4/Indications";
import Module_4_ISI from "./pages/Module-4/isi";
import Module_400 from "./pages/Module-4/400";
import Module_410 from "./pages/Module-4/410";
import Module_411 from "./pages/Module-4/411";
import Module_412 from "./pages/Module-4/412";
import Module_413 from "./pages/Module-4/413";
import Module_414 from "./pages/Module-4/414";
import Module_415 from "./pages/Module-4/415";
import Module_416 from "./pages/Module-4/416";
import Module_417 from "./pages/Module-4/417";
import Module_418 from "./pages/Module-4/418";
import Module_419 from "./pages/Module-4/419";
import Module_4110 from "./pages/Module-4/4110";
import Module_4111 from "./pages/Module-4/4111";
import Module_4112 from "./pages/Module-4/4112";
import Module_4113 from "./pages/Module-4/4113";
import Module_4114 from "./pages/Module-4/4114";
import Module_4115 from "./pages/Module-4/4115";
import Module_4116 from "./pages/Module-4/4116";
import Module_4117 from "./pages/Module-4/4117";
import Module_4118 from "./pages/Module-4/4118";
import Module_4119 from "./pages/Module-4/4119";
import Module_4120 from "./pages/Module-4/4120";
import Module_4121 from "./pages/Module-4/4121";
import Module_5_Overview from "./pages/Module-5/Overview";
import Module_5_Indications from "./pages/Module-5/Indications";
import Module_5_ISI from "./pages/Module-5/isi";
import Module_5_1_0 from "./pages/Module-5/510";
import Module_5_1_1 from "./pages/Module-5/511";
import Module_5_0_0 from "./pages/Module-5/500";
import Module_5_0_1 from "./pages/Module-5/501";
import Module_5_0_2 from "./pages/Module-5/502";
import Module_5_0_3 from "./pages/Module-5/503";
import Module_5_0_4 from "./pages/Module-5/504";
import Module_5_0_5 from "./pages/Module-5/505";

import Overview from "./pages/Overview";
import Certiicate from "./pages/Certificate";
import FormTest from "./pages/formTest";
import VideoTest from "./pages/Video";

import Sitemap from "./pages/sitemap.js";

// Error Pages
import NotFoundA from "./pages/404-a.js";
import MaintenanceB from "./pages/maintenance-b.js";

// Define public routes accessible to all users
const publicRoutes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/formtest",
    element: <FormTest />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/resources",
    element: <Resources />,
  },
  {
    path: "/register/:uuid",
    element: <Register />,
  },
  {
    path: "/forgot",
    element: <ForgotPassword />,
  },
  {
    path: "/reset/:token",
    element: <ResetPassword />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/logout",
    element: <Logout />,
  },
  {
    path: "/maintenance",
    element: <MaintenanceB />,
  },
  {
    path: "/sitemap",
    element: <Sitemap />,
  },
  {
    path: "/*",
    element: <NotFoundA />,
  },
];

// Define routes accessible only to authenticated users
const PrivateRoute = [
  {
    path: "/",
    element: <ProtectedRoute />, // Wrap the component in ProtectedRoute
    children: [
      {
        path: "/profile",
        element: <Profile />,
      },
      // module 1 route
      {
        path: "/module-1/overview",
        element: <Module_1_Overview />,
      },
      {
        path: "/module-1/indications",
        element: <Module_1_Indications />,
      },
      {
        path: "/module-1/isi",
        element: <Module_1_ISI />,
      },
      {
        path: "/module-1/module-1-0-1",
        element: <Module_101 />,
      },
      {
        path: "/module-1/module-1-0-2",
        element: <Module_102 />,
      },
      {
        path: "/module-1/module-1-0-3",
        element: <Module_103 />,
      },
      {
        path: "/module-1/module-1-0-4",
        element: <Module_104 />,
      },
      {
        path: "/module-1/module-1-1-1",
        element: <Module_111 />,
      },
      {
        path: "/module-1/module-1-1-2",
        element: <Module_112 />,
      },
      /* {
        path: "/module-1/module-1-1-3",
        element: <Module_113 />,
      },
      {
        path: "/module-1/module-1-1-4",
        element: <Module_114 />,
      }, */
      {
        path: "/module-1/module-1-2-1",
        element: <Module_121 />,
      },
      {
        path: "/module-1/module-1-2-2",
        element: <Module_122 />,
      },
      {
        path: "/module-1/module-1-2-3",
        element: <Module_123 />,
      },
      {
        path: "/module-1/module-1-2-4",
        element: <Module_124 />,
      },
      {
        path: "/module-1/module-1-2-5",
        element: <Module_125 />,
      },
      {
        path: "/module-1/module-1-3-1",
        element: <Module_131 />,
      },
      {
        path: "/module-1/module-1-3-2",
        element: <Module_132 />,
      },
      {
        path: "/module-1/module-1-3-3",
        element: <Module_133 />,
      },
      {
        path: "/module-1/module-1-3-4",
        element: <Module_134 />,
      },
      {
        path: "/module-1/module-1-3-5",
        element: <Module_135 />,
      },
      {
        path: "/module-1/module-1-3-6",
        element: <Module_136 />,
      },
      // module 2 route
      {
        path: "/module-2/overview",
        element: <Module_2_Overview />,
      },
      {
        path: "/module-2/indications",
        element: <Module_2_Indications />,
      },
      {
        path: "/module-2/isi",
        element: <Module_2_ISI />,
      },
      {
        path: "/module-2/module-2-0-0",
        element: <Module_200 />,
      },
      {
        path: "/module-2/module-2-1-1",
        element: <Module_211 />,
      },
      {
        path: "/module-2/module-2-1-2",
        element: <Module_212 />,
      },
      {
        path: "/module-2/module-2-1-3",
        element: <Module_213 />,
      },
      {
        path: "/module-2/module-2-1-4",
        element: <Module_214 />,
      },
      {
        path: "/module-2/module-2-1-5",
        element: <Module_215 />,
      },
      {
        path: "/module-2/module-2-2-0",
        element: <Module_220 />,
      },
      {
        path: "/module-2/module-2-2-1",
        element: <Module_221 />,
      },

      {
        path: "/module-2/module-2-2-2",
        element: <Module_222 />,
      },
      {
        path: "/module-2/module-2-2-3",
        element: <Module_223 />,
      },
      {
        path: "/module-2/module-2-2-4",
        element: <Module_224 />,
      },
      {
        path: "/module-2/module-2-2-5",
        element: <Module_225 />,
      },
      {
        path: "/module-2/module-2-2-6",
        element: <Module_226 />,
      },

      {
        path: "/module-2/module-2-2-7",
        element: <Module_227 />,
      },
      {
        path: "/module-2/module-2-2-8",
        element: <Module_228 />,
      },
      {
        path: "/module-2/module-2-2-9",
        element: <Module_229 />,
      },
      {
        path: "/module-2/module-2-2-10",
        element: <Module_2210 />,
      },
      {
        path: "/module-2/module-2-2-11",
        element: <Module_2211 />,
      },

      {
        path: "/module-2/module-2-3-0",
        element: <Module_230 />,
      },
      {
        path: "/module-2/module-2-3-1",
        element: <Module_231 />,
      },
      {
        path: "/module-2/module-2-3-2",
        element: <Module_232 />,
      },
      {
        path: "/module-2/module-2-3-3",
        element: <Module_233 />,
      },
      {
        path: "/module-2/module-2-3-4",
        element: <Module_234 />,
      },
      {
        path: "/module-2/module-2-3-5",
        element: <Module_235 />,
      },

      {
        path: "/module-2/module-2-3-6",
        element: <Module_236 />,
      },
      {
        path: "/module-2/module-2-3-7",
        element: <Module_237 />,
      },
      {
        path: "/module-2/module-2-3-8",
        element: <Module_238 />,
      },

      {
        path: "/module-2/module-2-4-0",
        element: <Module_240 />,
      },

      {
        path: "/module-2/module-2-4-1",
        element: <Module_241 />,
      },
      {
        path: "/module-2/module-2-4-2",
        element: <Module_242 />,
      },
      {
        path: "/module-2/module-2-4-3",
        element: <Module_243 />,
      },

      {
        path: "/module-2/module-2-4-4",
        element: <Module_244 />,
      },
      {
        path: "/module-2/module-2-4-5",
        element: <Module_245 />,
      },
      {
        path: "/module-2/module-2-4-6",
        element: <Module_246 />,
      },
      {
        path: "/module-2/module-2-4-7",
        element: <Module_247 />,
      },
      {
        path: "/module-2/module-2-4-8",
        element: <Module_248 />,
      },
      {
        path: "/module-2/module-2-4-9",
        element: <Module_249 />,
      },
      {
        path: "/module-2/module-2-4-10",
        element: <Module_2410 />,
      },
      {
        path: "/module-2/module-2-4-11",
        element: <Module_2411 />,
      },
      // module 3 route
      {
        path: "/module-3/overview",
        element: <Module_3_Overview />,
      },
      {
        path: "/module-3/indications",
        element: <Module_3_Indications />,
      },
      {
        path: "/module-3/isi",
        element: <Module_3_ISI />,
      },
      {
        path: "/module-3/module-3-0-0",
        element: <Module_300 />,
      },
      {
        path: "/module-3/module-3-0-1",
        element: <Module_301 />,
      },
      {
        path: "/module-3/module-3-0-2",
        element: <Module_302 />,
      },
      {
        path: "/module-3/module-3-0-3",
        element: <Module_303 />,
      },
      {
        path: "/module-3/module-3-0-4",
        element: <Module_304 />,
      },
      {
        path: "/module-3/module-3-0-5",
        element: <Module_305 />,
      },
      {
        path: "/module-3/module-3-0-6",
        element: <Module_306 />,
      },
      {
        path: "/module-3/module-3-0-7",
        element: <Module_307 />,
      },
      {
        path: "/module-3/module-3-0-8",
        element: <Module_308 />,
      },
      {
        path: "/module-3/module-3-0-9",
        element: <Module_309 />,
      },
      {
        path: "/module-3/module-3-0-10",
        element: <Module_3010 />,
      },
      {
        path: "/module-3/module-3-0-11",
        element: <Module_3011 />,
      },
      {
        path: "/module-3/module-3-0-12",
        element: <Module_3012 />,
      },
      {
        path: "/module-3/module-3-0-13",
        element: <Module_3013 />,
      },
      {
        path: "/module-3/module-3-0-14",
        element: <Module_3014 />,
      },
      {
        path: "/module-3/module-3-0-15",
        element: <Module_3015 />,
      },
      {
        path: "/module-3/module-3-0-16",
        element: <Module_3016 />,
      },
      {
        path: "/module-3/module-3-0-17",
        element: <Module_3017 />,
      },
      {
        path: "/module-3/module-3-0-18",
        element: <Module_3018 />,
      },
      {
        path: "/module-3/module-3-0-19",
        element: <Module_3019 />,
      },
      {
        path: "/module-3/module-3-0-20",
        element: <Module_3020 />,
      },
      {
        path: "/module-3/module-3-0-21",
        element: <Module_3021 />,
      },
      // module 4 route
      {
        path: "/module-4/overview",
        element: <Module_4_Overview />,
      },
      {
        path: "/module-4/indications",
        element: <Module_4_Indications />,
      },
      {
        path: "/module-4/isi",
        element: <Module_4_ISI />,
      },
      {
        path: "/module-4/module-4-0-0",
        element: <Module_400 />,
      },
      {
        path: "/module-4/module-4-1-0",
        element: <Module_410 />,
      },
      {
        path: "/module-4/module-4-1-1",
        element: <Module_411 />,
      },
      {
        path: "/module-4/module-4-1-2",
        element: <Module_412 />,
      },
      {
        path: "/module-4/module-4-1-3",
        element: <Module_413 />,
      },
      {
        path: "/module-4/module-4-1-4",
        element: <Module_414 />,
      },
      {
        path: "/module-4/module-4-1-5",
        element: <Module_415 />,
      },
      {
        path: "/module-4/module-4-1-6",
        element: <Module_416 />,
      },
      {
        path: "/module-4/module-4-1-7",
        element: <Module_417 />,
      },
      {
        path: "/module-4/module-4-1-8",
        element: <Module_418 />,
      },
      {
        path: "/module-4/module-4-1-9",
        element: <Module_419 />,
      },
      {
        path: "/module-4/module-4-1-10",
        element: <Module_4110 />,
      },
      {
        path: "/module-4/module-4-1-11",
        element: <Module_4111 />,
      },
      {
        path: "/module-4/module-4-1-12",
        element: <Module_4112 />,
      },
      {
        path: "/module-4/module-4-1-13",
        element: <Module_4113 />,
      },
      {
        path: "/module-4/module-4-1-14",
        element: <Module_4114 />,
      },
      {
        path: "/module-4/module-4-1-15",
        element: <Module_4115 />,
      },
      {
        path: "/module-4/module-4-1-16",
        element: <Module_4116 />,
      },
      {
        path: "/module-4/module-4-1-17",
        element: <Module_4117 />,
      },
      {
        path: "/module-4/module-4-1-18",
        element: <Module_4118 />,
      },
      {
        path: "/module-4/module-4-1-19",
        element: <Module_4119 />,
      },
      {
        path: "/module-4/module-4-1-20",
        element: <Module_4120 />,
      },
      {
        path: "/module-4/module-4-1-21",
        element: <Module_4121 />,
      },
      // module 5 route
      {
        path: "/module-5/overview",
        element: <Module_5_Overview />,
      },
      {
        path: "/module-5/indications",
        element: <Module_5_Indications />,
      },
      {
        path: "/module-5/isi",
        element: <Module_5_ISI />,
      },
      {
        path: "/module-5/module-5-0-0",
        element: <Module_5_0_0 />,
      },
      {
        path: "/module-5/module-5-0-1",
        element: <Module_5_0_1 />,
      },
      {
        path: "/module-5/module-5-0-2",
        element: <Module_5_0_2 />,
      },
      {
        path: "/module-5/module-5-0-3",
        element: <Module_5_0_3 />,
      },
      {
        path: "/module-5/module-5-0-4",
        element: <Module_5_0_4 />,
      },
      {
        path: "/module-5/module-5-0-5",
        element: <Module_5_0_5 />,
      },
      {
        path: "/module-5/module-5-1-0",
        element: <Module_5_1_0 />,
      },
      {
        path: "/module-5/module-5-1-1",
        element: <Module_5_1_1 />,
      },

      {
        path: "/certificate",
        element: <Certiicate />,
      },
      {
        path: "/overview",
        element: <Overview />,
      },
      {
        path: "/video",
        element: <VideoTest />,
      },
    ],
  },
];

const router = createBrowserRouter([...publicRoutes, ...PrivateRoute]);

export default router;
